import * as React from 'react';

import { Field } from 'redux-form';

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';

import type { JobFieldProps } from './job-field';

import { JobField } from './job-field';

import { JobFinalizingHireStepsReduxFormField } from '../../widgets/redux-form-fields/job-finalizing-hire-steps-redux-form-component';

const styles = () =>
  createStyles({
    formField: {
      width: '100%',
    },
  });

interface Props extends JobFieldProps, WithStyles<typeof styles> {
  commonFinalizingHireSteps: Array<FinalizingHireStep>;
}

export const JobFieldFinalizingHireSteps = withStyles(styles)((props: Props) => {
  const { classes, commonFinalizingHireSteps } = props;
  const childrenProps: Partial<Props> = { ...props };
  delete childrenProps.classes;
  return (
    <div className={classes.formField}>
      <JobField
        {...childrenProps}
        title="Pre-hire Steps"
        caption="Add the things an applicant needs to complete after their interview before you hire them."
        editView={
          <Field
            name="JobFinalizingHireSteps"
            component={JobFinalizingHireStepsReduxFormField}
            commonFinalizingHireSteps={commonFinalizingHireSteps}
          />
        }
      />
    </div>
  );
});
